import { MESSAGE_VARIABLES } from 'shared/constants/messages';

export const CONTACT_CUSTOM_ATTRIBUTE_VARIABLE_PREFIX =
  'contact.custom_attributes.';

export const buildContactCustomAttributeVariables = (
  contactAttributes = []
) => {
  return contactAttributes.map(attr => ({
    label: attr.attribute_display_name || attr.attribute_key,
    key: `${CONTACT_CUSTOM_ATTRIBUTE_VARIABLE_PREFIX}${attr.attribute_key}`,
  }));
};

export const buildMessageVariableOptions = (contactAttributes = []) => {
  const customAttributeVariables = buildContactCustomAttributeVariables(
    contactAttributes
  );

  if (!customAttributeVariables.length) {
    return MESSAGE_VARIABLES;
  }

  return [...MESSAGE_VARIABLES, ...customAttributeVariables];
};
